'use strict';

const BaseModel = require('./baseModel');

class ApplicantTask extends BaseModel {
  constructor() {
    super(applicantTaskSchema);
  }

  static getSchema() {
    return applicantTaskSchema;
  }
}

const applicantTaskSchema = {
  taskTypeId: {
    required: {
      message: 'This field is required.'
    }
  },
  message: {
    isLength: {
      options: {max: 255},
      message: 'Max length is 255 characters.'
    }
  }
};

module.exports = ApplicantTask;



// WEBPACK FOOTER //
// ./shared/models/applicantTask.js